<div class="modal-header">
  <h3 class="modal-title">Select processes</h3>
  <button
    type="button"
    class="close"
    (click)="close()"
    aria-label="Close"
    tabindex="1">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="form-group row">
    <div class="col-sm-12">
      <app-organization-search
        #pmtSearchableList
        (selectedOrganizationsChange)="changeFilter($event)"
        [indent]="10"
        [includeType]="true"
        [showTags]="true"
        [includeFields]="false"
        [retainPreviousSearch]="false"
        [type]="'hierarchy'"
        [debounceEnabled]="true"
        [selectedOrganizations]="organizationData"
        [placeholder]="'Filter by process hierarchy'"></app-organization-search>
    </div>
  </div>
</div>

<div class="modal-footer justify-content-between">
  <button
    type="button"
    class="btn btn-secondary btn-sm"
    (click)="close()"
    tabindex="3">
    Cancel
  </button>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-sm"
      (click)="save()"
      tabindex="4">
      Done
    </button>
  </div>
</div>
